// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2020-05-07 23:37:11 +0200 (Thu, 07 May 2020) $
//  Author    : Albert Charlier, Dirk Rothe, Tobias Schwarzkopf
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 110228 $
//  Purpose   : page headers
// =============================================================================
// --- Third-party imports
import React from 'react'
import {Label, Icon, Menu} from 'semantic-ui-react'

// --- Framework imports
import {get} from 'ldash'
import {funcPart} from 'uix/parts'
import {Actions, Sel} from 'uix/registries'
import log from 'uix/logging'
import {QuickSearchInput} from 'uix/modules/search/components'
import {Link, DebugFeature} from 'uix/components'
import {useSelector} from 'uix/hooks'

// --- Globals
const BackendLink = ({}) => {
  let {id, tabname} = useSelector(Sel.request)
  let ancestorAxis = useSelector(Sel.ancestorAxis)

  // obscure rules that will be streamlined
  let nextTabname = tabname == 'viewer' ? 'viewer' : 'id'
  if (ancestorAxis[0]?.datatype == 2) {
    nextTabname = 'wiki'
  }

  return (
    <Link classname="tree" tabname={nextTabname} id={id} title="BACKEND">
      <Icon name="sitemap" style={{color: 'black'}} />
    </Link>
  )
}

export const ProtoHeader = funcPart(({request}) => {
  let {id, tabname} = request
  return (
    <Menu id="mobileTop" borderless attached>
      <Menu.Item id="topLogo" fitted>
        <Link classname="proto" tabname="home" id={null} title="HOME" />
      </Menu.Item>
      <Menu.Item position="right" fitted="vertically">
        <Icon name="search" />
        <QuickSearchInput width="100px" />
      </Menu.Item>
      <Menu.Item icon="bars" />
      <DebugFeature>
        <Menu.Item disabled={!id}>
          <BackendLink />
        </Menu.Item>
      </DebugFeature>
    </Menu>
  )
})
